<template>
  <div class="row">
    <div
      v-if="!loaded"
      class="text-center mt-5">
      <i class="fa fa-spinner fa-spin fa-2x fa-fw"/>
      <span class="sr-only">Loading...</span>
    </div>
    <layouts-create
      v-if="loaded"
      :edit="true"
    />
    <revisions />
  </div>
</template>

<script>
import LayoutsCreate from './../components/LayoutsCreate'
import { mapActions } from 'vuex'
import Revisions from '../components/Revisions.vue'

export default {
  name: 'LayoutsNew',
  components: {
    LayoutsCreate,
    Revisions
  },
  data () {
    return {
      loaded: false
    }
  },
  created () {
    this.getById(this.$route.params.id).then(() => {
      this.loaded = true

      const routeId = this.$route.params.id

      if (routeId) {
        this.getRevisionsByLayoutId({ id: routeId, page: 1 })
      }
    })
  },
  methods: {
    ...mapActions('layout', [
      'getById',
      'getRevisionsByLayoutId'
    ])
  }
}
</script>
